<template>
	<div>
		<div class="content">
			<div class="container help-center">
				<leftAbout></leftAbout>
				<div class="help-main">
					<h2>回收流程</h2>
					<div class="help-cont">
						<ul class="stepflow-group clearfix">
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-sign icon-weibiaoti5"></i>
								</div>
								<div class="title">注册账号</div>
								<div class="flow">
									登录{{$namePc}}
								</div>
								<div class="num">01</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-realname icon-shimingrenzheng"></i>
								</div>
								<div class="title">实名认证</div>
								<div class="flow">
									绑定提现账号
								</div>
								<div class="num">02</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-input icon-tijiao"></i>
								</div>
								<div class="title">提交卡密</div>
								<div class="flow">
									等待平台验卡
								</div>
								<div class="num">03</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-verify icon-yanzheng"></i>
								</div>
								<div class="title">验卡成功</div>
								<div class="flow">
									相应资金到账
								</div>
								<div class="num">04</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-cash icon-tixian1"></i>
								</div>
								<div class="title">账户提现</div>
								<div class="flow">
									银行或支付宝
								</div>
								<div class="num">05</div>
							</li>
							<li>
								<div class="icon">
									<i class="iconfont iconfont-step-completed icon-wancheng"></i>
								</div>
								<div class="title">交易成功</div>
								<div class="flow">
									推荐给朋友
								</div>
								<div class="num">06</div>
							</li>
						</ul>
						<div class="stepflow-tips">
							<ul>
								<li>
									1、帐号请绑定手机号码，以便我们处理您提交的卡出现问题时可以及时和您联系；
								</li>
								<li>
									2、请务必按照格式提交正确的卡号卡密，以免浪费您的时间并给您造成不必要的困扰；
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import leftAbout from '../common/about/index.vue'
	export default{
		data(){
			return{

			}
		},
		components:{
			leftAbout
		},
		created(){

		},
		methods:{

		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/about/flow.vue